const DocMenuConfig = [
  {
    pages: [
      {
        heading: "dashboard",
        route: "/dashboard",
        svgIcon: "media/icons/duotune/art/art002.svg",
        fontIcon: "bi-app-indicator",
      },
      /* {
        heading: "layoutBuilder",
        route: "/builder",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-layers",
      }, */
    ],
  },
  {
    heading: "system",
    route: "/system",
    pages: [
      /* {
        sectionTitle: "systems",
        route: "/systems",
        svgIcon: "media/icons/duotune/communication/com006.svg",
        fontIcon: "bi-person",
        sub: [
          {
            heading: "accounts",
            route: "/systems/accounts",
          },
          {
            heading: "roles",
            route: "/systems/roles",
          },
          {
            heading: "menus",
            route: "/systems/menus",
          },
        ],
      }, */
      /* {
        sectionTitle: "catalogs",
        route: "/catalogs",
        svgIcon: "media/icons/duotune/communication/com005.svg",
        fontIcon: "bi-journal",
        sub: [
          {
            heading: "banks",
            route: "/catalogs/banks",
          },
        ],
      }, */
    ],
  },
  {
    heading: "examples",
    route: "/examples",
    pages: [
      {
        sectionTitle: "pages",
        route: "/pages",
        svgIcon: "media/icons/duotune/general/gen022.svg",
        fontIcon: "bi-archive",
        sub: [
          {
            sectionTitle: "profile",
            route: "/profile",
            sub: [
              {
                heading: "profileOverview",
                route: "/examples/pages/profile/overview",
              },
              {
                heading: "projects",
                route: "/examples/pages/profile/projects",
              },
              {
                heading: "campaigns",
                route: "/examples/pages/profile/campaigns",
              },
              {
                heading: "documents",
                route: "/examples/pages/profile/documents",
              },
              {
                heading: "connections",
                route: "/examples/pages/profile/connections",
              },
              {
                heading: "activity",
                route: "/examples/pages/profile/activity",
              },
            ],
          },
          {
            sectionTitle: "wizards",
            route: "/wizard",
            sub: [
              {
                heading: "horizontal",
                route: "/examples/pages/wizards/horizontal",
              },
              {
                heading: "vertical",
                route: "/examples/pages/wizards/vertical",
              },
            ],
          },
        ],
      },
      {
        sectionTitle: "account",
        route: "/account",
        svgIcon: "media/icons/duotune/communication/com006.svg",
        fontIcon: "bi-person",
        sub: [
          {
            heading: "accountOverview",
            route: "/examples/account/overview",
          },
          {
            heading: "settings",
            route: "/examples/account/settings",
          },
        ],
      },
      {
        sectionTitle: "authentication",
        svgIcon: "media/icons/duotune/technology/teh004.svg",
        fontIcon: "bi-sticky",
        sub: [
          {
            sectionTitle: "basicFlow",
            sub: [
              {
                heading: "signIn",
                route: "/sign-in",
              },
              /* {
                heading: "signUp",
                route: "/sign-up",
              }, */
              {
                heading: "passwordReset",
                route: "/password-reset",
              },
            ],
          },
          {
            heading: "error404",
            route: "/404",
          },
          {
            heading: "error500",
            route: "/500",
          },
        ],
      },
      {
        sectionTitle: "modals",
        route: "/modals",
        svgIcon: "media/icons/duotune/art/art009.svg",
        fontIcon: "bi-shield-check",
        sub: [
          {
            sectionTitle: "general",
            route: "/general",
            sub: [
              {
                heading: "viewUsers",
                route: "/examples/modals/general/view-user",
              },
              {
                heading: "upgradePlan",
                route: "/examples/modals/general/upgrade-plan",
              },
            ],
          },
          {
            sectionTitle: "forms",
            route: "/forms",
            sub: [
              {
                heading: "newTarget",
                route: "/examples/modals/forms/new-target",
              },
              {
                heading: "newCard",
                route: "/examples/modals/forms/new-card",
              },
              {
                heading: "newAddress",
                route: "/examples/modals/forms/new-address",
              },
              {
                heading: "createAPIKey",
                route: "/examples/modals/forms/create-api-key",
              },
            ],
          },
          {
            sectionTitle: "wizards",
            route: "/wizards",
            sub: [
              {
                heading: "twoFactorAuth",
                route: "/examples/modals/wizards/two-factor-auth",
              },
              {
                heading: "createApp",
                route: "/examples/modals/wizards/create-app",
              },
              {
                heading: "createAccount",
                route: "/examples/modals/wizards/create-account",
              },
            ],
          },
        ],
      },
      {
        sectionTitle: "examples",
        route: "/widgets",
        svgIcon: "media/icons/duotune/general/gen025.svg",
        fontIcon: "bi-layers",
        sub: [
          {
            heading: "widgetsLists",
            route: "/examples/widgets/lists",
          },
          {
            heading: "widgetsStatistics",
            route: "/examples/widgets/statistics",
          },
          {
            heading: "widgetsCharts",
            route: "/examples/widgets/charts",
          },
          {
            heading: "widgetsMixed",
            route: "/examples/widgets/mixed",
          },
          {
            heading: "widgetsTables",
            route: "/examples/widgets/tables",
          },
          {
            heading: "widgetsFeeds",
            route: "/examples/widgets/feeds",
          },
        ],
      },
    ],
  },
];

export default DocMenuConfig;
